import { Portal } from "@mui/base";
import { useAccountStore } from "../../stores/accountStore";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";

export default function TrialNotification() {
  const [account] = useAccountStore((state) => [state.account], shallow);
  const { t } = useTranslation();

  const isTrial = account.subscription.subscription_id === "Trial";
  const daysLeft = account.trial_days_left;

  if (!isTrial || process.env.REACT_APP_ENV === "sandbox") {
    return null;
  }

  return (
    <Portal>
      <div className="trial-notification">
        <p className="trial-notification__title">{t("trial_notification.title", { daysLeft: daysLeft })}</p>

        <a
          className="trial-notification__help"
          href={t("settings.logout.calendly_link")}
          target="_blank"
          rel="noreferrer"
        >
          {t("trial_notification.help")}
        </a>
      </div>
    </Portal>
  );
}
